<template>
  <div class="menu_top" style="z-index: 1999;">
    <div class="box">
      <div class="img">
        <span></span>
        <span></span>
      </div>
      <div class="menu">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item :class="$route.fullPath.indexOf(i.path) !== -1 ? 'active' : ''" :index="index.toString()" v-for="(i,index) in navigationList" :key="index">
            <span>{{i.name}} <i></i>
            </span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="user">
        <span class="ling" @click="jump('notice')">
          <img src="../assets/imgs/lingdang.svg" alt="">
          <i class="i" v-show="is"></i>
        </span>
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <i class="el-icon-user-solid"> <span class="name">{{username_c}}</span> </i><i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="jump('information')">用户信息</el-dropdown-item>
            <el-dropdown-item @click.native="jump('pass')">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="exit">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import navigationList from '../tool/navigation.js'
import { queryHasRead_c } from '../api/interface'
export default {
  data () {
    return {
      navigationList: navigationList.navigationList_c,
      activeIndex: '0',
      username_c: '',
      is: false,
      timer: null
    }
  },
  created () {
    this.phone_c = localStorage.getItem('phone_c')
    this.email_c = localStorage.getItem('email_c')
    this.username_c = localStorage.getItem('username_c')
    queryHasRead_c({ userId: localStorage.getItem('userid_c') }).then(res => {
      this.is = res.data
      if(res.data){
      this.timer = setInterval(() => {
      queryHasRead_c({ userId: localStorage.getItem('userid_c') }).then(res => {
        this.is = res.data
      })
      }, 3000)
    } else {
      clearInterval(this.timer);
      this.timer = null;
    }
    })
    
  },
  beforeDestroy () {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    handleSelect (index, indexPath) {
      if (this.$route.fullPath !== this.navigationList[Number(indexPath[0])].path) {
        this.$router.push({
          path: this.navigationList[Number(indexPath[0])].path
        })
      }
    },
    jump (type) {
      console.log(this.$route.query.name);
      if (this.$route.query.name != type) {
        this.$router.push({
          path: '/layout_c/user',
          query: {
            name: type
          }
        })
      }
    },
    exit () {
      this.$confirm('确定退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setTimeout(() => {
          localStorage.removeItem('username_c')
          localStorage.removeItem('phone_c')
          localStorage.removeItem('email_c')
          localStorage.removeItem('token_c')
          this.$router.push('/home')
          this.$message({
            type: 'success',
            duration: 1000,
            showClose: true,
            message: '退出成功!'
          });
        }, 300)
        clearInterval(this.timer);
        this.timer = null;
      }).catch(() => {
        this.$message({
          type: 'info',
          duration: 1000,
          showClose: true,
          message: '已取消退出'
        });
      });
    }
  }
}
</script>

<style lang="less" scoped>
.menu_top {
  text-align: center;
  .box {
    height: 60px;
    display: inline-block;
    width: 1200px;
  }
  position: fixed;
  left: 0;
  right: 0;
  height: 60px;
  background: rgba(0, 0, 0, 0.8);
  .img {
    float: left;
    width: 340px;
    height: 60px;
    padding-top: 15px;
    margin-right: 30px;
    span {
      float: right;
    }
    span:nth-child(1) {
      display: inline-block;
      width: 150px;
      height: 35px;
      background: url("../assets/imgs/gukedabei.png");
      background-size: 100% 100%;
    }
    span:nth-child(2) {
      display: inline-block;
      width: 150px;
      height: 35px;
      margin-right: 30px;
      background: url("../assets/imgs/zhongkeyuan.png");
      background-size: 100% 100%;
    }
  }
  .menu {
    float: left;
    height: 60px;
    width: 630px;
    /deep/.el-menu {
      .active {
        span {
          color: #fff !important;
          background-color: transparent;
          i {
            position: relative;
            top: -18px;
            margin: 0 auto;
            display: block;
            width: 16px;
            height: 2px;
            background: #0067e4;
          }
        }
      }
      border-bottom: none;
      background: transparent;
      .el-menu-item {
        margin-right: 30px;
        color: #989898;
        &:hover {
          background-color: transparent;
        }
      }
      .is-active {
        background-color: transparent;
        border-bottom: none;
      }
    }
  }
  .user {
    // position: relative;
    float: right;
    height: 60px;
    line-height: 60px;
    .ling {
      position: relative;
    }
    img {
      cursor: pointer;
      width: 17px;
      height: 17px;
      position: relative;
      top: 3px;
      margin-right: 20px;
    }
    .el-dropdown-link {
      cursor: pointer;
      .el-icon-user-solid {
        display: inline-block;
        color: #fff;
        font-size: 17px;
      }
      .name {
        max-width: 120px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 14px;
        display: inline-block;
        margin-left: 5px;
      }
      .el-icon--right {
        color: #fff;
      }
    }
    .i {
      position: absolute;
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #f86b12;
      border-radius: 50%;
      top: 0;
      right: 20px;
    }
  }
}
</style>